<div class="sheet-container">

    <div class="icon">
        📦
    </div>
    <h2>Pending Web Orders</h2>

    <p>
        You have
        <strong>{{data.count}}</strong>
        pending web order{{data.count > 1 ? 's' : ''}}
        awaiting your action.
    </p>

    <p class="sub-text">
        Would you like to review them now?
    </p>

    <div class="button-container">
        <button mat-stroked-button class="later-btn" (click)="cancel()">
            Later
        </button>

        <button mat-raised-button class="proceed-btn" (click)="proceed()">
            Proceed
        </button>
        
    </div>
</div>